import { Box, useTheme } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import PageBanner from "../components/application/PageBanner";
import ProductsAndServices from "../components/application/ProductsAndServices";
import FileUploaderList from "../components/common/FileUploaderList";
import useScreen from "../components/common/UseScreen";
import { BannerTexts, SnackbarMsg } from "../data/texts";
import { Images } from "../models/assets-files";
import { VoidFunction } from "../models/common.models";
import { FileWithId } from "../models/uploaded-file";
import { FileService } from "../services/file.service";
import { ImageService } from "../services/image.service";
import { showSnackbar } from "../store/system.store";

interface LandingPageProps {
  onProductSelect: (href: string) => void;
}

const LandingPage = ({ onProductSelect }: LandingPageProps) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const onSubmitUploadFiles = async (
    filesWithId: FileWithId[],
    onSuccess: VoidFunction
  ) => {
    setIsLoading(true);
    await FileService.uploadFiles(filesWithId);
    dispatch(showSnackbar({ msg: SnackbarMsg.SNACKBAR_FILES_UPLOADED }));
    onSuccess();

    setIsLoading(false);
  };

  const { isMobile } = useScreen();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: isMobile ? "0" : "24px",
        background: theme.palette.background.default,
      }}
    >
      <PageBanner
        imageSrc={ImageService.getLocalImgPath(
          Images.Folders.BANNERS,
          Images.Banners.LAPTOP_BIG,
          "png"
        )}
        title={BannerTexts.WELCOME}
        subtitle={BannerTexts.BUSINESS_DESCRIPTION}
        containerSx={{ marginBottom: isMobile ? "0" : "32px" }}
      />
      <Box sx={{ padding: isMobile ? "24px" : "0" }}>
        <Box
          sx={{
            background: "white",
            paddingBlock: "35px",
            paddingInline: "28px",
            borderRadius: "6px",
            boxShadow: theme.custom.cardBoxShadow,
            marginBottom: "32px",
          }}
        >
          <FileUploaderList
            isLoading={isLoading}
            onSubmit={onSubmitUploadFiles}
          />
        </Box>
        <ProductsAndServices onProductSelect={onProductSelect} />
      </Box>
    </Box>
  );
};

export default LandingPage;
